// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__9gD5x","content":"GlobalSearch_content__36HVX"};